import _ from "lodash";
import React, { useState } from "react";
import classes from "./ReportSubmissionItem.scss";
import classNames from "classnames";
import { CreateDropDown } from "Attachment/index";
import { TextAreaInput, TextInput } from "@toddle-edu/ds-web";
import ProjectsAttachmentList from "Projects/components/ProjectsAttachmentList";
import { submissionItemDefaultProps } from "Projects/modules/ProjectModules";
import { isTextInputFieldType } from "Projects/modules/Utils";

const styles = {
  createButtonComponentStyle: {
    icon: "AddOutlined",
    size: "medium",
    type: "ICON_BUTTON_V2",
    variant: "neutral",
    iconType: "outlined",
  },
  attachmentContainerStyle: {
    gap: "16px",
  },
};

const TEST_ID_PREFIX = "projects-reportSubmissionItem";

const SubmissionItem = ({
  itemResponse,
  onUpdateInputField,
  onUpdateAttachment,
  onCreateAttachment,
  disabled,
  onAttachmentClick,
  onDeleteAttachment,
  isUserStudentOrParent,
  t,
  projectId,

  // dropdown and fieldConfig props
  title: submissionItemTitle,
  subTitle: submissionItemSubTitle,
  dropDownOptions,
  showSimilarity,

  isAnnotationEnabled,
  multiselect,
  canAddMaximumAttachments,
  defaultExportType,
  attachmentExportOptions,
  accept,
  maxSize,
  excludeFileExtensionsList,
  onEditAttachmentClick,
  showPdfTronEditButton,
  togglePdfTronEditButton,
  // for non attachment fields
  fieldType,
  placeholder: fieldPlaceholder,
  autoCheckSimilarityRef,
  submissionId,
}) => {
  const {
    submissionItem: { fieldUID },
    value,
    attachments,
    id: submissionItemResponseId,
  } = itemResponse;

  const [localFieldValues, setLocalFieldValues] = useState({
    [fieldUID]: value,
  });

  const fieldValue = localFieldValues[fieldUID];
  const handleInputChange = value => {
    setLocalFieldValues({
      [fieldUID]: value,
    });
    onUpdateInputField({
      submissionResponseId: submissionItemResponseId,
      value,
    });
  };

  const handleUpdateAttachment = ({ attachmentId, newName }) => {
    const attachmentToUpdate = _.cloneDeep(
      _.find(attachments, { id: attachmentId })
    );
    attachmentToUpdate["name"] = newName;
    onUpdateAttachment({
      attachmentToUpdate,
    });
  };

  const handleAttachmentClick = item => {
    isUserStudentOrParent
      ? undefined
      : onAttachmentClick({
          selectedAttachmentId: item.id,
          isAnnotationEnabled,
        });
  };

  const isTextInput = _.includes(["InputField", "TextArea"], fieldType);
  const isInputField = isTextInputFieldType({ fieldType });
  return (
    <div
      className={classNames({
        [classes.itemResponseContainer]: true,
        [classes.disabledContainer]: disabled,
      })}
    >
      <div
        className={classNames("text-body", classes.itemResponseLeftContainer)}
      >
        <div>{t(submissionItemTitle)}</div>
        {submissionItemSubTitle ? (
          <div
            className={classNames(
              "text-body-s",
              classes.submissionItemSubTitle
            )}
          >
            {t(submissionItemSubTitle)}
          </div>
        ) : null}
      </div>

      {isInputField ? (
        <div
          className={classNames("text-body-2", {
            [classes.submissionItemValueRightContainer]: disabled,
            [classes.submissionItemValueRightContainerTextbox]: !disabled,
          })}
        >
          {disabled ? (
            fieldValue
          ) : (
            <div className={classes.textInputContainer}>
              {isTextInput ? (
                <TextAreaInput
                  value={fieldValue}
                  onChange={e => handleInputChange(e.target.value)}
                  maxRows={2}
                  rows={1}
                />
              ) : (
                <TextInput
                  value={fieldValue}
                  onChange={e => handleInputChange(e.target.value)}
                  variant="plain"
                  placeholder={fieldPlaceholder}
                  type={"number"}
                />
              )}
            </div>
          )}
        </div>
      ) : (
        <div className={classes.itemResponseRightContainer}>
          {_.size(attachments) > 0 ? (
            <div className={classes.submissionItemAttachmentsContainer}>
              <ProjectsAttachmentList
                value={attachments}
                showCreateDropDown={false}
                shouldCallMutation={false}
                showLocalAttachmentsInViewMode={true}
                createDropdownComponent={<span></span>}
                onClickAttachmentCard={
                  isUserStudentOrParent ? undefined : handleAttachmentClick
                }
                onDeleteAttachmentCallback={({ attachmentId }) => {
                  onDeleteAttachment({
                    attachmentIds: [attachmentId],
                    submissionId,
                  });
                }}
                mediaCardSize={"small"}
                renameAttachmentCallBack={handleUpdateAttachment}
                mode={disabled ? "view" : "edit"}
                dropdownIconButtonSize="small"
                alwaysShowActions={true}
                showDeleteModal={true}
                showAttachmentInfo={true}
                projectId={projectId}
                showSimilarity={showSimilarity}
                attachmentContainerStyleProps={styles.attachmentContainerStyle}
                autoCheckSimilarityRef={autoCheckSimilarityRef}
                onEditAttachmentClick={onEditAttachmentClick}
                showPdfTronEditButton={showPdfTronEditButton}
                togglePdfTronEditButton={togglePdfTronEditButton}
                showEditResponseButton={isAnnotationEnabled && !disabled}
                showNewTabOption={true}
              />
            </div>
          ) : null}
          {!disabled &&
            (!canAddMaximumAttachments ||
              (canAddMaximumAttachments &&
                _.size(attachments) < canAddMaximumAttachments)) && (
              <div className={classes.createDropdownContainer}>
                <CreateDropDown
                  multiple={true}
                  isNewDropdown={true}
                  parentId={submissionItemResponseId}
                  parentType="PROJECT_SUBMISSION_ITEM_RESPONSE"
                  addAttachment={attachments => {
                    onCreateAttachment({
                      attachments,
                      parentId: submissionItemResponseId,
                      submissionId,
                    });
                  }}
                  dsVersion="2.0"
                  createButtonComponentConfig={
                    styles.createButtonComponentStyle
                  }
                  dropDownOptions={dropDownOptions}
                  multiselect={multiselect}
                  defaultExportType={defaultExportType}
                  attachmentExportOptions={attachmentExportOptions}
                  accept={accept}
                  maxSize={maxSize}
                  excludeFileExtensionsList={excludeFileExtensionsList}
                  useIconWithDropdownOptions={true}
                  testId={`${TEST_ID_PREFIX}-${fieldUID}`}
                />
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default SubmissionItem;

SubmissionItem.defaultProps = submissionItemDefaultProps;
